<!--
numLine：显示的列数
sumData: 总体数据
方法：
this.$refs.pickerBox.showBox() 显示盒子
this.$refs.pickerBox.setPicker(obj) 设置当前显示元素
-->
<template>
    <div class="bang-picker" :class="showDate?'active':''">
        <div class="picker-box">
            <div class="tit-box">
                <p class="btn cancel" @click="hideBox">取消</p>
                <p class="btn" @click="sure">确定</p>
            </div>
            <div class="list-box" ref="box" @touchstart="stopTouch">
                <child-slot v-for="i in numLine" v-bind:key="i" :ref="'box'+(i-1)" :slotsKey="i-1"
                            v-on:eventPicker="changePicker">
                </child-slot>
            </div>
        </div>
    </div>
</template>

<script>
    import ChildSlot from './childSlot'

    export default {
        name: "bang-picker",
        components: {
            ChildSlot
        },
        data() {
            return {
                showDate: false,
                chooseVal: {},
            }
        },
        props: {
            numLine: Number,
            sumData: Array,
        },
        mounted() {
        },
        methods: {
            showBox() {
                this.$refs.box.style.height = "200px";
                this.showDate = true
                this.chooseVal = {}
            },
            hideBox() {
                this.$refs.box.style.height = "0";
                setTimeout(() => {
                    this.showDate = false
                }, 300)
            },
            stopTouch(e) {
                e.preventDefault();
            },
            changePicker(data) {
                if (data.chooseVal.child && Object.getOwnPropertyNames(this.chooseVal).length > this.numLine) {
                    this.$refs[`box${data.index + 1}`][0].setList(data.chooseVal.child, 0)
                }
                this.chooseVal[data.index] = {
                    code: data.chooseVal.code,
                    name: data.chooseVal.name
                };
            },
            setPicker(data) {
                for (var a = 0; a < this.sumData.length; a++) {
                    if (this.sumData[a].code == data[0].code) {
                        this.$refs[`box${0}`][0].setList(this.sumData, a)
                        var twoArr = this.sumData[a].child
                        //判断是否有第二级
                        if (twoArr.length > 0) {
                            for (var b = 0; b < twoArr.length; b++) {
                                //遍历第二级是否有相等元素
                                if (twoArr[b].code == data[1].code) {
                                    this.$refs[`box${1}`][0].setList(twoArr, b)
                                    var threeArr = twoArr[b].child
                                    //判断是否有第三级
                                    if (threeArr && threeArr.length > 0) {
                                        for (var c = 0; c < threeArr.length; c++) {
                                            //遍历第三级是否有相等元素
                                            if (threeArr[c].code == data[2].code) {
                                                this.$refs[`box${2}`][0].setList(threeArr, c)
                                                break
                                            }
                                        }
                                    }
                                    break
                                }
                            }
                        }

                        break
                    }

                }
            },

            sure() {
                this.hideBox()
                this.$emit('eventPicker', this.chooseVal)
            }

        }
    }
</script>

<style scoped lang="less">
    @theme: #4877bd;
    @font: #fff;
    .bang-picker {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 99;
        width: 100%;
        height: 0;
        background: rgba(0, 0, 0, .5);
        overflow: hidden;

        &.active {
            height: 100vh;
        }
        .picker-box {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            background: @font;
            .tit-box {
                position: relative;
                height: 45px;
                line-height: 45px;
                border-bottom: solid 1px #eee;
                font-size: 14px;
                display: flex;
                padding: 0 5%;
                p {
                    flex: 1;
                    color: @theme;
                    text-align: right;
                    &.cancel {
                        text-align: left;
                        color: #999;
                    }

                }
            }
            .list-box {
                position: relative;
                display: flex;
                width: 100%;
                height: 0;
                background: #f5f5f5;
                overflow: hidden;
                transition: all .3s;
                .line {
                    position: relative;
                    z-index: 2;
                    flex: 1;
                    width: 100%;
                    height: 200px;
                    ul {
                        width: 100%;
                        height: 200px;
                        transition: all .5s;
                        li {
                            width: 100%;
                            height: 40px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            line-height: 40px;
                            text-align: center;
                            font-size: 14px;
                            opacity: .5;
                            color: #666;
                            transition: all .3s;
                            &.active {
                                opacity: 1;
                            }
                        }
                    }
                }
                &:after {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    right: 0;
                    height: 40px;
                    margin-top: -20px;
                    width: 100%;
                    z-index: 1;
                    background: #fff;
                    border-top: solid 1px #eee;
                    border-bottom: solid 1px #eee;
                    content: '';
                }

            }
        }
    }

</style>